import { RepeatDropdownOptions } from "../../types/block/enum";

const RecurrenceRuleMap = {
  [RepeatDropdownOptions.EVERY_DAY]: {
    text: RepeatDropdownOptions.EVERY_DAY,
    rule: "RRULE:FREQ=DAILY",
  },
  [RepeatDropdownOptions.EVERY_WEEKDAY]: {
    text: RepeatDropdownOptions.EVERY_WEEKDAY,
    rule: "RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR",
  },
  [RepeatDropdownOptions.EVERY_WEEK]: {
    text: RepeatDropdownOptions.EVERY_WEEK,
    rule: "RRULE:FREQ=WEEKLY",
  },
  [RepeatDropdownOptions.EVERY_MONTH]: {
    text: RepeatDropdownOptions.EVERY_MONTH,
    rule: "RRULE:FREQ=MONTHLY",
  },
  [RepeatDropdownOptions.EVERY_YEAR]: {
    text: RepeatDropdownOptions.EVERY_YEAR,
    rule: "RRULE:FREQ=YEARLY",
  },
} as const;

/**
 * recurrenceRule을 받아서 text를 반환
 * @param rule
 * @returns
 */
const getRecurrenceText = (rule: string): string | null => {
  const matchedRecurrenceRule = Object.values(RecurrenceRuleMap).find(({ rule: r }) => r === rule);
  return matchedRecurrenceRule?.text ?? null;
};

/**
 * text를 받아서 recurrenceRule을 반환
 * @param value
 * @returns
 */
export const textToRRule = (value: keyof typeof RecurrenceRuleMap) => {
  return RecurrenceRuleMap[value as keyof typeof RecurrenceRuleMap].rule;
};

/**
 * recurrenceRule을 받아서 text를 반환
 * @param value
 * @returns
 */
export const rRuleToText = (value: string[]) => {
  if (!value || value.length === 0) {
    return null;
  }

  const stringValue = value[0];

  // ;UNTIL이 있는 것도 포함되도록 처리
  const untilPattern = /^(RRULE:FREQ=(DAILY|WEEKLY|MONTHLY|YEARLY)(;BYDAY=[A-Z,]*)?);UNTIL=/;
  const match = stringValue?.match(untilPattern);

  const baseRule = match ? match[1] : stringValue;

  // 단일 요일을 포함하는 EVERY_WEEK 패턴 처리
  const singleDayPattern = /^RRULE:FREQ=WEEKLY;BYDAY=[A-Z]{2}$/;
  if (singleDayPattern.test(baseRule)) {
    return RepeatDropdownOptions.EVERY_WEEK;
  }

  const recurrenceText = getRecurrenceText(baseRule);
  if (recurrenceText) {
    return recurrenceText;
  }

  // 일치하는 규칙이 없으면 New Repeat Settings 반환
  return RepeatDropdownOptions.NEW_REPEAT_SETTINGS;
};
